<div class="dashboard-navigation">
  <div 
    class="mapfre card nav-content-card" 
    [class.iphonex]="checkForIphoneType()">
    <div class="drop-up-container" *ngIf="showMore && hiddenCount > 0">
      <div class="expanded-line" (click)="toggleMoreMenu()"></div>
      <ul class="hidden-row"> 
        <li *ngFor="let i of navItemList.slice(0, navItemList.length - hiddenCount - 1)" class="hidden-text">
          <div>{{i.nativeElement?.innerText}}</div>
        </li>       
        <li *ngFor="let item of hiddenNavItems; index as i">
          <a 
            class="nav_icon"
            [routerLink]='item.routerLink'
            routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: false}"
            title=item.title
            mdbRipple
          >
            <div class="nav-content nav-icon">
              <div class="non-active-icon icon-content">
                <img class="id-card-img-icon" src={{item.nonActiveIcon}} alt="{{item.title}} icon" />
              </div>
              <div class="active-icon icon-content">
                <ng-container *ngIf="isAcmic && item.title === 'Contact'; else nonActiveIcon">
                  <svg-contact-filled-svg></svg-contact-filled-svg>
                </ng-container>
                <ng-template #nonActiveIcon>
                  <img class="id-card-img-icon" src={{item.activeIcon}} alt="{{item.title}} icon" />
                </ng-template>
              </div>
            </div>
            <div class="nav-content nav-copy">
                {{ item.title }}
            </div>
          </a>
        </li>
      </ul>
    </div>
    <ul>
      <li #menuItem>
        <a class="nav_icon"
          routerLink="/home"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: false}"
          title="{{ 'Home' | translate }}"
          mdbRipple>

          <ng-container *ngIf="isAcmic; else homeMAstateIcon">
             <div class="nav-content nav-icon">
              <div class="non-active-icon icon-content icon-wrapper">
                <img src="./assets/img/images/home-menu-acmic-icon.svg" alt="home menu icon" />
              </div>
              <div class="active-icon icon-content icon-wrapper">
                <img src="./assets/img/images/home-menu-active-acmic-icon.svg" alt="home menu icon" loading="lazy" />
              </div>
            </div>
          </ng-container>
          <ng-template #homeMAstateIcon>
            <div class="nav-content nav-icon">
              <div class="non-active-icon icon-content icon-wrapper">
                <img src="./assets/img/images/home-menu-icon.svg" alt="home menu icon" />
              </div>
              <div class="active-icon icon-content icon-wrapper">
                <img src="./assets/img/images/home-menu-active-icon.svg" alt="active home menu icon" loading="lazy" />
              </div>
            </div>
          </ng-template>          
          <div class="nav-content nav-copy">
              {{ 'Home' | translate }}
          </div>
        </a>
      </li>

      <li #menuItem>
        <a class="nav_icon"
          routerLink="/my-insurance"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: false}"
          title="{{ 'Policies' | translate }}"
          mdbRipple>

          <ng-container *ngIf="isAcmic; else myInsuranceMAstateIcon">
            <div class="nav-content nav-icon">
              <div class="non-active-icon icon-content icon-wrapper">
                <img src="./assets/img/images/menuicon-policies-acmic.svg" alt="myinsurance menu icon" />
              </div>
               <div class="active-icon icon-content icon-wrapper">
                <img src="./assets/img/images/menuicon-policies-active-acmic.svg" alt="home menu icon" loading="lazy" />
              </div>
            </div>
          </ng-container>
          <ng-template #myInsuranceMAstateIcon>
            <div class="nav-content nav-icon">
              <div class="non-active-icon icon-content icon-wrapper">
                <img src="./assets/img/images/menuicon-myinsurance-new.svg" alt="myinsurance menu icon" />
              </div>
              <div class="active-icon icon-content icon-wrapper">
                <img src="./assets/img/images/menuicon-policies-active-new.svg" alt="active myinsurance menu icon" loading="lazy" />
              </div>
            </div>
          </ng-template>          
          <div class="nav-content nav-copy">
              {{ 'Policies' | translate }}
          </div>
        </a>
      </li>

      <!-- Billing nav -->

      <li #menuItem>
        <a class="nav_icon"
          routerLink="/billing-new"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: false}"
          title="{{ 'Billing' | translate }}"
          mdbRipple>

          <ng-container *ngIf="isAcmic; else billingMAstateIcon">
            <div class="nav-content nav-icon">
              <div class="non-active-icon icon-content icon-wrapper">
                <img src="./assets/img/images/Icon-Pay-Bill-Inactive.svg" alt="billing menu icon" />
              </div>
              <div class="active-icon icon-content icon-wrapper">
                <img src="./assets/img/images/Icon-Pay-Bill-Active.svg" alt="billing menu icon" loading="lazy" />
              </div>
            </div>
          </ng-container>
          <ng-template #billingMAstateIcon>
            <div class="nav-content nav-icon">
              <div class="non-active-icon icon-content icon-wrapper">
                <img src="./assets/img/images/pay-bill-icon.svg" alt="billing menu icon" />
              </div>
              <div class="active-icon icon-content icon-wrapper">
                <img src="./assets/img/images/pay-bill-active-icon.svg" alt="active billing menu icon" loading="lazy" />
              </div>
            </div>
          </ng-template>          
          <div class="nav-content nav-copy">
              {{ 'Billing' | translate }}
          </div>
        </a>
      </li>

      <li #menuItem *ngIf="this.showCompany==='tw' || this.showCompany === 'ma' || this.showCompany === 'all'">
        <a class="nav_icon" 
          routerLink="/claims"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: false}"
          title="{{ 'CLAIMS' | translate }}"
          mdbRipple>
          <ng-container *ngIf="isAcmic; else claimsMAstateIcon">
            <div class="nav-content nav-icon">
              <div class="non-active-icon icon-content icon-wrapper">
               <img src="./assets/img/images/menuicon-claims-acmic.svg" alt="claim menu icon" loading="lazy" />
              </div>
              <div class="active-icon icon-content icon-wrapper"> 
                <svg-claims-filled-svg></svg-claims-filled-svg>
              </div>
            </div>
          </ng-container>
          <ng-template #claimsMAstateIcon>
            <div class="nav-content nav-icon">
              <div class="non-active-icon icon-content icon-wrapper">
                <img src="./assets/img/images/menuicon-claims.svg" alt="claim menu icon" loading="lazy" />
              </div>
              <div class="active-icon icon-content icon-wrapper"> 
                <img src="./assets/img/images/menuicon-claims-active.svg" alt="active claim menu icon" loading="lazy" />
              </div>
            </div>
          </ng-template>          
          <div class="nav-content nav-copy">
              {{ 'CLAIMS' | translate }}
          </div>
        </a>
      </li>
                             
      <li #menuItem *ngIf="!isAcmic && (showCompany==='ma' || showCompany==='all')">
        <a class="nav_icon"
          routerLink="/faq"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: false}"
          title="FAQ"
          mdbRipple>
          <div class="nav-content nav-icon">
              <div class="non-active-icon icon-content icon-wrapper">
                <img src="./assets/img/images/menuicon-faq.svg" alt="faq menu icon" loading="lazy" />
              </div>
              <div class="active-icon icon-content icon-wrapper">
                <img src="./assets/img/images/menuicon-faq-active.svg" alt="active faq emnu icon" loading="lazy" />
              </div>
          </div>
          <div class="nav-content nav-copy">
              FAQ
          </div>
        </a>
      </li>
      <li #menuItem *ngIf="isAcmic && activePolicies?.length && isActiveAuto">
        <a class="nav_icon"
          routerLink="/id-cards"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: false}"
          title="ID Cards"
          mdbRipple>
          <div class="nav-content nav-icon">
              <div class="non-active-icon icon-content icon-wrapper">
                <img class="id-card-img-icon" src="./assets/img/images/icon-id-card.svg" alt="faq menu icon" loading="lazy" />
              </div>
              <div class="active-icon icon-content icon-wrapper">
                <img class="id-card-img-icon" src="./assets/img/images/id-cards-menu-icon-active.svg" alt="active faq emnu icon" loading="lazy" />
              </div>
          </div>
          <div class="nav-content nav-copy">
              ID Cards
          </div>
        </a>
      </li>
      <li #menuItem>
        <a class="nav_icon"
          routerLink="/contact"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}"
          [ngClass]="{'iphone-padding':iphone}"
          title="{{ 'CONTACT' | translate }}"
          mdbRipple>
          <ng-container *ngIf="isAcmic; else contactMAstateIcon">
            <div class="nav-content nav-icon">
              <div class="non-active-icon icon-content icon-wrapper">
                <img src="./assets/img/images/Icon-Call.svg" alt="contact menu icon" />
              </div>
              <div class="active-icon icon-content icon-wrapper">
                <svg-contact-filled-svg></svg-contact-filled-svg>
              </div>
            </div>
          </ng-container>
          <ng-template #contactMAstateIcon>
            <div class="nav-content nav-icon">
              <div class="non-active-icon icon-content icon-wrapper">
                <img src="./assets/img/images/menuicon-contact.svg" alt="contact menu icon" loading="lazy" />
              </div>
              <div class="active-icon icon-content icon-wrapper">
                <img src="./assets/img/images/menuicon-contact-active.svg" alt="active contact menu icon" loading="lazy" />
              </div>
            </div>
          </ng-template>          
            <div class="nav-content nav-copy">
                {{ 'CONTACT' | translate }}
          </div>
        </a>
      </li>      

      <li *ngIf="hiddenCount > 0">
         <a class="nav_icon" (click)="toggleMoreMenu()" mdbRipple>
           <div class="nav-content nav-icon">
              <div class="non-active-icon icon-content icon-wrapper">
                <img src={{moreIcon}} alt="more icon" />
              </div>
            </div>
            <div class="nav-content nav-copy">
                {{ 'More' | translate }}
          </div>
         </a>
      </li>
    </ul>
  </div>
</div>